/* @ngInject */
export default function comparisonPageBootstrap($stateProvider, MPA_PAGES) {
  $stateProvider.state(MPA_PAGES.COMPARISON.name, {
    url: MPA_PAGES.COMPARISON.url,
    component: 'comparisonPageComponent',
    resolve: {}
  })
}
